import { IOperationHandler } from '@ms/items-view/lib/private/store/actions/implementOperation';
import { spItemNextGroupPageKeyFacet, spFolderItemSetKeyFacet } from '../../../dataSource/Keys';
import { getItemsOperation } from '@ms/items-view/lib/private/operations/getItemsOperation';
import {
  createSingleItemOperationHandler,
  ISingleOperationPayload,
  IOperationHandlerThunkAction
} from '@ms/items-view/lib/private/addons/registerOperationHandler';
import { IItemCacheDispatch } from '@ms/items-view/lib/private/store/actions/ItemCacheActions';
import { getContentTypes, constructGetItemSetContext } from '../../../dataSource/getServerDataContext';
import { getServerData } from '../../../dataSource/getServerData';
import { processResponse } from '../../../dataSource/processResponse';
import { resolveExistingPage } from '@ms/items-view/lib/private/models/items/PageHelpers';

export const spItemNextGroupPageGetItemsOperationHandler:
  IOperationHandler<typeof spItemNextGroupPageKeyFacet.type, typeof getItemsOperation.type> = createSingleItemOperationHandler({
    maxParallelOperationCount: 8
  })(getSPItemNextGroupPage);

function getSPItemNextGroupPage(
  payload: ISingleOperationPayload<typeof spItemNextGroupPageKeyFacet.type, typeof getItemsOperation.type>
): IOperationHandlerThunkAction {
  const {
    itemSetKey,
    nextGroupXml,
    nextGroupLevel,
    filterParams,
    token
  } = spItemNextGroupPageKeyFacet.deserialize(payload.itemKey);
  return async (dispatch: IItemCacheDispatch) => {
    const serializedItemSetKey = spFolderItemSetKeyFacet.serialize(itemSetKey);
    const updatedItemSetKey = {
      ...itemSetKey,
      ...(filterParams && { filterParams: filterParams } || {})
    };
    const contentTypes = dispatch(getContentTypes({ itemSetKey }));
    const getItemContext = await dispatch(constructGetItemSetContext({
      itemSetKey: updatedItemSetKey,
      contentTypes: contentTypes,
      pageToken: token,
      fetchNextGroupXml: nextGroupXml,
      qosName: 'getSPItemNextGroupPage'
    }));

    const serverData = await dispatch(getServerData(getItemContext));

    const {
      itemResolver,
      childKeys,
      groupChildKeys,
      groupLevel
    } = dispatch(processResponse({
      serverData,
      itemSetKey,
      currentPageContext: getItemContext.currentPageContext,
      contentTypes,
      fetchNextGroupXml: nextGroupXml,
      nextGroupLevel,
      isItemSetRequest: true
    }));

    if (groupLevel === 1 && nextGroupLevel === 1) {
      // This signifies we were fetching the next nested group. Merge new nested groups into owning first level group.
      const firstGroupKey = childKeys[0];

      itemResolver.merge(resolveExistingPage({
        itemKey: payload.itemKey,
        itemSetKey: firstGroupKey,
        childItemKeys: groupChildKeys[firstGroupKey] || []
      }).itemResolver);
    } else {
      // This signifies we were fetching the next first level group. Merge new first level groups into the item set.
      itemResolver.merge(resolveExistingPage({
        itemKey: payload.itemKey,
        itemSetKey: serializedItemSetKey,
        childItemKeys: childKeys
      }).itemResolver);
    }

    dispatch(itemResolver.execute());
  };
}
